import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  Icon,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { IoSearchOutline } from "react-icons/io5";
import { TbDeviceIpadHorizontalSearch } from "react-icons/tb";
import { CiMail } from "react-icons/ci";
import { useTheme } from "@emotion/react";
import { AppEntryRepository } from "../repositories/AppEntryRepository";
import { Enumerations } from "../../config/Enumerations";
import { TbCopyCheckFilled } from "react-icons/tb";
import { useDispatch } from "react-redux";
import { notifyShowErrorMessage } from "../../store/AlertSlice";
import { ErrorMessageResolver } from "../common/ErrorMessageResolver";
import { FaLocationArrow } from "react-icons/fa";

export default function EntryStatusPanel() {
  const theme = useTheme();
  const [trackingNumber, setTrackingNumber] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const checkAppEntryStatus = () => {
    setError(null);
    setLoading(true);
    setResponse(null);
    AppEntryRepository.checkStatus(trackingNumber, email)
      .then((res) => {
        setLoading(false);
        setResponse(res.data);
      })
      .catch((err) => {
        setLoading(false);
        setResponse(null);
        console.error("Error checking status:", err);
        dispatch(notifyShowErrorMessage(ErrorMessageResolver.resolve(err)));
        setError(ErrorMessageResolver.resolve(err));
      });
  };

  return (
    <Grid item xs={12} md={6}>
      <Paper
        elevation={2}
        sx={{
          padding: 2,
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            fontSize: { xs: "36px", md: "48px" },
          }}
        >
          <TbDeviceIpadHorizontalSearch
            color="#e59900"
            style={{ flexShrink: 0 }}
          />
          <Typography
            variant="h6"
            style={{
              fontFamily: "Inter-Medium",
              color: "#171718",
              lineHeight: "1",
            }}
          >
            Провери статус на барање
          </Typography>
        </Box>
        <Typography
          style={{
            marginTop: "10px",
            fontSize: "15px",
            fontFamily: "Inter-Regular",
            color: theme.palette.secondary.main,
            lineHeight: "1.2",
            textAlign: "left",
          }}
        >
          По успешно поднесување на барањето, можете да го следите неговиот
          статус со внесување на идентификаторот на барањето и вашата е-пошта.
        </Typography>
        {response && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              width: "100%",
              marginTop: "10px",
              padding: "5px 0",
              justifyContent: "flex-start",
              backgroundColor: "#eaf5ff",
            }}
          >
            <TbCopyCheckFilled
              color="#008cff"
              size={25}
              style={{ padding: "0 20px" }}
            />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <Typography style={{ fontSize: "14px" }}>
                Статус на барање
              </Typography>
              <Typography
                style={{
                  fontSize: "16px",
                  fontFamily: "Inter-Bold",
                  color: theme.palette.primary.main,
                }}
              >
                {Enumerations.AppEntryStatus[response] || "Нема информации"}
              </Typography>
            </Box>
          </Box>
        )}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
            alignItems: "center",
            marginTop: "15px",
            width: "100%",
          }}
        >
          <TextField
            fullWidth
            label="Идентификатор на барање"
            autoComplete="off"
            value={trackingNumber || ""}
            onChange={(e) => {
              setTrackingNumber(e.target.value);
              setResponse(null);
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">BR</InputAdornment>
              ),
            }}
          />
          <TextField
            fullWidth
            label="Е-пошта"
            autoComplete="off"
            value={email || ""}
            onChange={(e) => {
              setEmail(e.target.value);
              setResponse(null);
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <CiMail color="#818181" size={20} />
                </InputAdornment>
              ),
            }}
          />
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              padding: "10px 20px",
            }}
          >
            <Button
              size="large"
              variant="contained"
              color="warning"
              disabled={loading || !trackingNumber || !email}
              sx={{
                width: "180px",
                "&.Mui-disabled": {
                  backgroundColor: "#e59900",
                  color: "white",
                  cursor: "not-allowed",
                  pointerEvents: "auto",
                  opacity: 1,
                },
              }}
              onClick={checkAppEntryStatus}
            >
              {!loading ? (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <Typography
                    style={{
                      fontFamily: "Inter-Regular",
                      fontSize: "16px",
                      color: "#fff",
                    }}
                  >
                    Провери
                  </Typography>
                  <IoSearchOutline fontSize={18} color="#fff" />
                </div>
              ) : (
                <CircularProgress
                  size={20}
                  id="circular-progress"
                  style={{ padding: "2px" }}
                />
              )}
            </Button>
          </Box>
        </Box>
      </Paper>
      <Paper sx={{ mt: 2 }}>
        <Alert
          color="secondary"
          variant="info"
          icon={<FaLocationArrow color={theme.palette.warning.main} />}
          sx={{ alignItems: "center", p: 0, pl: 2 }}
        >
          Локација: Ул. „Плоштад Црвена Скопска Општина“ бр. 4, Скопје |
          Телефон: 02 3145 497 | Е-пошта: info@mtc.gov.mk
        </Alert>
      </Paper>
    </Grid>
  );
}
